var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-scroller" }, [
    _c(
      "div",
      { staticClass: "container-fluid page-body-wrapper full-page-wrapper" },
      [
        _c(
          "div",
          { staticClass: "content-wrapper d-flex align-items-center auth" },
          [
            _c(
              "transition",
              { attrs: { name: "component-fade", mode: "out-in" } },
              [_c("router-view")],
              1
            )
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }